// RelatedProfile.js
import React from 'react';
import { LuWallet } from "react-icons/lu";
import { PiSuitcaseSimpleLight } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { HiOutlineAcademicCap } from "react-icons/hi2";
import { IoSettingsOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';

export const jobProfiles = [
  {
    id: 1,
    name: 'Abhishek Mishra',
    image: 'https://i.pravatar.cc/150?img=15',
    experience: '5yrs 6m',
    education: 'B.Sc. in Computer Science',
    skills: 'JavaScript, React, Node.js',
    location: 'Banglore, India',
    salary: '₹ 12-15 Lacs P.A.'
  },
  {
    id: 2,
    name: 'Madhav R',
    image: 'https://i.pravatar.cc/150?img=22',
    experience: '3yrs 2m',
    education: 'B.A. in Design',
    skills: 'Figma, Adobe XD, Wireframing',
    location: 'Hyderabad, India',
    salary: '₹ 8-10 Lacs P.A.'
  },

  {
    id: 3,
    name: 'Karunakar',
    image: 'https://i.pravatar.cc/150?img=13',
    experience: '8yrs 2m',
    education: 'B.A. in Design',
    skills: 'Figma, Adobe XD, Wireframing',
    location: 'Hyderabad, India',
    salary: '₹ 5-7.25 Lacs P.A.'
  },

  {
    id: 4,
    name: 'Venkatesh Tekkem',
    image: 'https://i.pravatar.cc/150?img=15',
    experience: '7yrs 2m',
    education: 'B.S.C in Design',
    skills: 'Figma, Adobe XD, Wireframing',
    location: 'Hyderabad, India',
    salary: '₹ 3-4.25 Lacs P.A.'
  },
  // Add more profiles as needed
];

function RelatedProfile() {
  const navigate = useNavigate();

  const handleProfileClick = (id) => {
    navigate(`/profile/${id}`);
  };

  return (
    <div className="container">
      <div className="row">
        {jobProfiles.map(profile => (
          <div
            className='col-12 card rounded-4 p-2 mb-4'
            key={profile.id}
            onClick={() => handleProfileClick(profile.id)}
            style={{ cursor: 'pointer' }}
          >
            <div className="d-flex align-items-stretch p-4" key={profile.id}>
              <div className='flex-grow-1'>
                <div className="me-3">
                  <h5 className="card-title">{profile.name}</h5>
                  <span className="card-text small">000{profile.id}</span>
                  <div className='d-lg-flex d-sm-block'>
                    <div className="card-text small mt-3 me-3">
                      <LuWallet className="me-2" /> {profile.salary}
                    </div>
                    <div className="card-text mt-3 small me-3">
                      <PiSuitcaseSimpleLight className="me-2" /> {profile.experience}
                    </div>

                  </div>
                  <div className='d-flex mt-3'>
                    <div className="card-text small">
                      <HiOutlineAcademicCap className="me-2" /> {profile.education}
                    </div>
                  </div>
                  <div className='d-flex mt-3'>
                    <div className="card-text small">
                      <IoSettingsOutline className="me-2" /> {profile.skills}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <img src={profile.image} className="img-thumbnail rounded-circle border-0" alt={profile.name} style={{ maxWidth: '60px' }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RelatedProfile; // Default export
